(() => {
  function normalizeCuratedLinks(root = document) {
    const halloweenTarget = root.querySelector('[data-cb-halloween-url]')?.dataset.cbHalloweenUrl;
    if (!halloweenTarget) return;

    document
      .querySelectorAll('.header a[href="/collections/halloween"], #menu-drawer a[href="/collections/halloween"]')
      .forEach((link) => {
        link.setAttribute('href', halloweenTarget);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => normalizeCuratedLinks(document), { once: true });
  } else {
    normalizeCuratedLinks(document);
  }

  document.addEventListener('shopify:section:load', () => normalizeCuratedLinks(document));
})();
